import React, { FunctionComponent, useState } from 'react'

import {
  InputContainer,
  InputLabel,
  InputLeadingIcon,
  InputTextField,
  InputTrailingIcon,
} from '../sharedStyle'

import { IProps } from './IProps'
import { LabelSelectField } from './style'

export const LabelSelect: FunctionComponent<IProps> = ({
  fieldLabel,
  fieldColor,
  leadingIcon,
  trailingIcon,
  onChange,
  customWidth,
  customMargin,
  optionsArray,
}) => {
  const [isInputFocus, setIsInputFocus] = useState<boolean>(false)
  return (
    <InputContainer customWidth={customWidth} customMargin={customMargin}>
      <InputTextField>
        <LabelSelectField
          fieldColor={fieldColor}
          onChange={onChange ? e => onChange(e) : undefined}
          isLeadingIcon
          customWidth={customWidth}
          onFocus={() => setIsInputFocus(true)}
          onBlur={() => setIsInputFocus(false)}>
          {optionsArray}
        </LabelSelectField>
        {!leadingIcon || <InputLeadingIcon icon={leadingIcon} />}
        <InputLabel
          isLeadingIcon={!!leadingIcon}
          isTrailingIcon={!!trailingIcon}
          fieldColor={fieldColor}
          isForceLabel
          isInputFocus={isInputFocus}>
          {fieldLabel}
        </InputLabel>
        {
          // @ts-ignore
          !trailingIcon || <InputTrailingIcon icon={trailingIcon} />
        }
      </InputTextField>
    </InputContainer>
  )
}
